import { SharedConstants } from '@formbird/types';
export class UtilRules {
    static getRelatedName(eventName) {
        const ruleConstants = SharedConstants.RULESET_RELATIONSHIPS;
        const keys = Object.keys(ruleConstants);
        let relName;
        for (let i = 0; i < keys.length; i++) {
            if (ruleConstants[keys[i]].name === eventName) {
                relName = ruleConstants[keys[i]].relName;
                break;
            }
        }
        return relName;
    }
}
